export function capitalize(text) {
  return text.toString().charAt(0).toUpperCase() + text.toString().slice(1);
}